import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Stack, FontIcon, Label } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ErrorString } from './error-string';


export const TitleBar = (props) => {
  const {
    title, error, isActive, setActiveKeys, id, activeKeys, setActiveCallback, disableExpand,
  } = props;
  const i18n = useContext(I18nContext);

  const renderTitle = () => {
    let titleTpl = null;
    if (typeof title === 'string') {
      titleTpl = <Label className="collapse-title" >{i18n.getString(_TL_('{{item}}'), { item: title })}</Label>;
    } else {
      titleTpl = React.cloneElement(title, { isActive });
    }

    return titleTpl;
  };

  const renderError = () => {
    if (!error || typeof error === 'string') {
      return <ErrorString error={error} />;
    }
    return React.cloneElement(error);
  };

  const onClickHandler = () => {
    if (disableExpand) {
      return;
    }
    if (isActive) {
      const tempActiveKeys = activeKeys.filter(item => item !== id);
      setActiveKeys(tempActiveKeys);
    } else {
      setActiveKeys([...activeKeys, id]);
    }
    setActiveCallback();
  };

  const onKeyPressHandler = (e) => {
    if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
      onClickHandler(e);
    }
  };

  const ariaTitle = useMemo(() => {
    if (typeof title === 'string') {
      return title;
    } else if (title && title.props && !_.isEmpty(title.props.titleKey)) {
      return title.props.titleKey;
    }
    return '';
  }, [title]);

  return (
    <Stack horizontal verticalAlign="top" horizontalAlign="space-between" className="collapse-title-bar" onClick={(e) => { onClickHandler(e); }} >
      <Stack.Item className="title-item" grow styles={{ root: { width: '857px' } }}>
        {renderTitle()}
      </Stack.Item>
      <Stack.Item>
        <Stack horizontal tokens={{ childrenGap: 23 }} styles={{ root: { height: '24px', lineHeight: '24px' } }} >
          { !disableExpand &&
          <FontIcon
            className="toggle-icon"
            aria-label={isActive ? `${ariaTitle} ChevronUp` : `${ariaTitle} ChevronDown`}
            iconName={isActive ? 'ChevronUp' : 'ChevronDown'}
            tabIndex="0"
            onKeyPress={(e) => { onKeyPressHandler(e); }}
            aria-expanded={isActive}
            role="button"
          />}
        </Stack>
      </Stack.Item>
      <div className="error-string-wrapper">
        {renderError()}
      </div>
    </Stack >
  );
};

TitleBar.propTypes = {
  id: PropTypes.string.isRequired,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  isActive: PropTypes.bool.isRequired,
  activeKeys: PropTypes.arrayOf(PropTypes.string),
  setActiveKeys: PropTypes.func.isRequired,
  setActiveCallback: PropTypes.func,
  disableExpand: PropTypes.bool,
};
TitleBar.defaultProps = {
  activeKeys: [],
  disableExpand: false,
  error: '',
  setActiveCallback() {},
};

